module.exports = __webpack_public_path__ + "img/stock4.67e10faf.png";